module.exports = __webpack_public_path__ + "media/images/ui__textCross--dark-95979a2e6a1dd9ad996e856511a10944.png";